import { Table, Tag } from "antd";
import { useDraftBailiffRefine } from "hook/draft/bailiff/useDraftBailiffRefine";
import React from "react";
// import TableUser from "./table_user";
import TableAction from "./table_action";
import { getTime } from "util/time.function";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const BailiffTable = () => {
  // -------------------------- VAR -----------------------------
  const data = useDraftBailiffRefine();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const columns = [
    {
      title: "Tạo lúc",
      dataIndex: "createAt",
      key: "createAt",
      render: (_, record) => getCreateAt(record),
    },
    {
      title: "Transcript Lúc",
      dataIndex: "transcriptAt",
      key: "transcriptAt",
      render: (value) => getTime(value, "DD/MM/YYYY HH:mm:ss"),
    },
    {
      title: "Lấy task lúc",
      dataIndex: "supportingAt",
      key: "supportingAt",
      render: (value) => getTime(value, "DD/MM/YYYY HH:mm:ss"),
    },
    {
      title: "Tên file",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Trạng thái",
      dataIndex: "status",
      key: "status",
      render: (value) => getStatus(value),
    },
    {
      title: "#",
      dataIndex: "qc",
      key: "qc",
      fixed: "right",
      render: (_, record) => <TableAction record={record} />,
    },
  ];

  const getStatus = (value) => {
    const color = value === "approval" ? "blue" : "orange";
    return <Tag color={color}>{value}</Tag>;
  };

  const getCreateAt = (record) => {
    const time = record?.createAt;
    return getTime(time, "DD/MM/YYYY HH:mm:ss");
  };

  // -------------------------- MAIN ----------------------------
  return (
    <Table
      size="small"
      bordered
      columns={columns}
      dataSource={data || []}
      loading={data === null}
      rowKey={"id"}
      scroll={{ x: "auto" }}
    />
  );
};
export default BailiffTable;
